import { BitMask } from './BitMask';

declare global {
  interface Window {
    apiStatusBinary: number;
  }
}

export enum ApiBitMaskTypes {
  GameSocket = 0b00000001,
  CasinoConfig = 0b00000010,
  EnvConfig = 0b00000100,
  PlayerConfig = 0b00001000,
  TableConfig = 0b00010000,
  Version = 0b00100000,
  Balance = 0b01000000,
  StatsSettings = 0b10000000,
}

class GlobalApiBitMask extends BitMask<ApiBitMaskTypes> {
  override apply(mask: ApiBitMaskTypes): void {
    super.apply(mask);
    window.apiStatusBinary = this.maskedBinary;
  }
}

export const ApiBitMask = new GlobalApiBitMask();
